import { render, staticRenderFns } from "./WsMainExpertHistory.vue?vue&type=template&id=4e71f079"
import script from "./WsMainExpertHistory.vue?vue&type=script&lang=js"
export * from "./WsMainExpertHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports